import React, {FC, useEffect, useState} from "react";
import {MenuInterface} from "../model/MenuInterface";
import {useParams} from "react-router-dom";
import axios from "axios";
import ContentVisual from "../components/ContentVisual";
import ContentHeader from "../components/ContentHeader";
import BoardContent from "../components/BoardContent";
import BoardPostContent from "../components/BoardPostContent";
import BoardEditContent from "../components/BoardEditContent";
import {useTypedSelector} from "../reducers";
import { handleError } from "../error/ErrorHandler";

type Props = {
    type: string;
}

const BoardPage: FC<Props> = ({ type }) => {
    const initMenuInfo: MenuInterface = {
        menuId: 0,
        menuNm: '',
        prtMenuId: 0,
        brdYn: '',
        brdId: 0,
        route: '',
        subList: []
    }

    let { menuId, brdId } = useParams();
    const { loginUser } = useTypedSelector(state => state.auth);
    const [menuInfo, setMenuInfo] = useState(initMenuInfo);
    const [siblings, setSiblings] = useState([initMenuInfo]);

    const getMenuInfo = async() => {
        try {
            const res = await axios.get(`/api/menu/one/${menuId}`);
            if (res.data) setMenuInfo(res.data);
        } catch(err) {
            handleError(err);
        }
    };

    const getSiblings = async() => {
        try {
            const res = await axios.get(`/api/menu/siblings/${menuId}`);
            if (res.data) {
                if (loginUser?.usrAuth !== 'A') {
                    let filteredMenus = res.data.filter((subMenu: MenuInterface, idx: number) => subMenu.menuNm !== '컨텐츠 관리')
                    setSiblings(filteredMenus);
                } else {
                    setSiblings(res.data);
                }
            }
        } catch(err) {
            handleError(err);
        }
    }

    useEffect(() => {
        getMenuInfo();
        getSiblings();
    }, [menuId, loginUser?.usrAuth]);

    return (
        <div className={'board-page-wrapper'}>
            <div className={'board-page-body'}>
                <ContentVisual title={menuInfo.menuNm} />
                <ContentHeader subMenuList={siblings} activeMenuId={Number(menuId)} />
                { type === 'board' && <BoardContent ctgId={menuInfo.brdId}/>}
                { type === 'post' && <BoardPostContent menuId={Number(menuId)} brdId={Number(brdId)} /> }
                { type === 'write' && <BoardEditContent menuId={Number(menuId)} ctgId={menuInfo.brdId} /> }
                { type === 'edit' && <BoardEditContent menuId={Number(menuId)} ctgId={menuInfo.brdId} brdId={Number(brdId)} /> }
            </div>
        </div>
    );
}

export default BoardPage;
